import React from "react";
import classNames from "classnames";
import { Container } from "./ReportReadonlyMessage"
import { ThemedSpan } from "../utilities";

export type ModalMessageContainerProps = {
    children?: React.ReactNode | undefined, 
    className?: any,
    text: string, 
    variant?: ThemeVariant
};

export const ModalMessageContainer = ({ 
    children, 
    className,
    text = "GENERIC MESSAGE", 
    variant = "muted" 
} : Readonly<ModalMessageContainerProps>) => (
    <Container className={classNames('py-3', className)}>
        {children}
        <ThemedSpan variant={variant}>{text}</ThemedSpan>
    </Container>
);